<template>
    <!-- Loading -->
    <div class="vld-parent">
      <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128"/>
    </div>
    <div class="full-container">
         <div class="sub-container_" v-for="filter in filterData.value" :key="filter" :style="'border: 3px solid'+getRandomColor()+';'">
            <div class="title-group">
                {{ filter.department_name }}
            </div>

            <div class="container_" v-for="group in Object.keys(dataGroup.value).filter((item) => item === filter.department_id)" :key="group">
              <div class="card">
                <div class="sub-content">
                    <div class="content " v-for="extcuri in dataGroup.value[group]" :key="extcuri" :style="'border: 0px solid; background-color:'+(extcuri.persen==100?'#c4c4c4':extcuri.set_color) +';' ">
                      <div class="title-content_" :style="'color:'+(extcuri.font_color)">
                      {{ extcuri.name }}
                      </div>
                      <div :style="'color:'+(extcuri.font_color)">{{ extcuri.department_name }}</div>
                      <!-- <div v-for="datax in extcuri.timeList" :key="datax" class="flex flex-col">
                        <div>{{ datax.day }} : </div>
                        <div>{{ datax.time1 }} - {{ datax.time2 }}</div>
                      </div> -->
                      <table>
                          <tr v-for="datax in extcuri.timeList" :key="datax" :style="'color:'+(extcuri.font_color)">
                            <td>{{ datax.day }}</td>
                            <td> : </td>
                            <td>{{ datax.time1 }} - {{ datax.time2 }}</td>
                          </tr>
                      </table>
                      <div class="text-xs pt-3 mt-3" :style="'color:'+(extcuri.font_color)">
                        {{ extcuri.already }}  /  {{ extcuri.capacity }}</div>
                      <div class="bar-capacity ">
                          <!-- <div class="bar-value"></div> -->
                          <div :style="'width:' + extcuri.persen + '%;'" class="bar-percentage bar-gray" v-if="extcuri.persen <= 0"></div>
                          <div :style="'width:' + extcuri.persen + '%;'" class="bar-percentage bar-green" v-if="extcuri.persen <= 50"></div>
                          <div :style="'width:' + extcuri.persen + '%;'" class="bar-percentage bar-yellow" v-else-if="extcuri.persen >= 51 && extcuri.persen <= 80"></div>
                          <div :style="'width:' + extcuri.persen + '%;'" class="bar-percentage bar-red" v-else-if="extcuri.persen >= 81 && extcuri.persen <= 100"></div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
  <script>
    // @ is an alias to /src
    import axios from 'axios'
    import {
      computed,
      ref,
      onMounted,
      watchEffect,
      reactive
    } from 'vue'
    import {
      useStore
    } from 'vuex'
    import { useToast } from 'vue-toastification'
    import {
      mdiAccountMultiple,
      mdiCartOutline,
      mdiChartTimelineVariant,
      mdiFinance,
      mdiMonitorCellphone,
      mdiReload,
      mdiGithub,
      mdiMagnify,
      mdiClose,
      mdiCogOutline,
      mdiTrashCan
    } from '@mdi/js'
    import '@vuepic/vue-datepicker/dist/main.css'
    // import Field from '@/components/Field'
    // import MainSection from '@/components/MainSection'
    // import JbButton from '@/components/JbButton'
    import { useI18n } from 'vue-i18n'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    // import Control from '@/components/Control'
    export default {
      name: 'Interest Selection',
      components: {
        Loading
        // JbButton,
        // Field,
        // MainSection,
        // Control
      },
      mounted () {
        this.backgroundColor = this.getRandomColor()
      },
      methods: {
        getRandomColor () {
          const min = 10
          const max = 15
          const letters = '0123456789ABCDEF'
          let color = '#'

          const redIndex = Math.floor(Math.random() * (max - min + 1)) + min
          color += letters[redIndex]

          // Generate green component
          const greenIndex = Math.floor(Math.random() * (max - min + 1)) + min
          color += letters[greenIndex]

          // Generate blue component
          const blueIndex = Math.floor(Math.random() * (max - min + 1)) + min
          color += letters[blueIndex]
          return color
        }
      },
      setup () {
         // eslint-disable-next-line
          /* eslint-disable */
        const titleStack = ref(['Admin', 'Dashboard'])
        const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
        const { t } = useI18n()
        const isLoading = ref(false)
        const store = useStore()
        const darkMode = computed(() => store.state.darkMode)
        const toast = useToast()

        const filter = reactive({
          department_id: '',
          department_name: ''
        })

        const dataGroup = reactive([])
        const showData = reactive([])
        const filterData = reactive([])
        const getData = async () => {
          const url = "/ext-time";
          const method = "GET";
          await axios({
            url,
            method,
            params: filter
          })
          .then(response => {
            showData.value = response.data.data
            dataGroup.value = response.data.group
            filterData.value = response.data.department

          }).catch(error => {
              toast.error(error.response.data, { timeout: 5000 })
              console.log(error)
              isLoading.value = false
          })
        }
        onMounted(() => {
          getData();
        });
        watchEffect(() => {
          const newGroup = dataGroup.value
          Object.assign(filter, newGroup)

        });
        return {
          isLoading,
          t,
          toast,
          titleStack,
          darkMode,
          mdiAccountMultiple,
          mdiCartOutline,
          mdiChartTimelineVariant,
          mdiFinance,
          mdiMonitorCellphone,
          mdiReload,
          mdiGithub,
          mdiMagnify,
          isAsideMobileExpanded,
          store,
          isAsideMobileExpanded,
          mdiClose,
          mdiCogOutline,
          mdiTrashCan,
          filterData,
          filter,
          getData,
          showData,
          dataGroup
        }
      }
    }
    function currencyFormatter (currency, sign) {
        if (currency !== undefined) {
            const sansDec = Number(currency).toFixed()
            const formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            return `${formatted}`
        }
    }
  </script>

  <style >
  .modal-wide {
  max-width: 800px;
  }
  .text-xs {
  padding-top: 3px;
  margin-top: 3px;
  }
  .grid-box{
  display: grid;
  grid-template-columns: auto auto;
  }
  @media screen and (max-width: 1280px){
  .left-content{
  width: 65%;
  }
  .title-container {
  margin-left: 15px;
  }
  .side-distance{
  margin-left: 15px !important;
  }
  .grid-box{
  grid-template-columns: auto;
  }
  }
  @media screen and (max-width: 768px){
  .full-page{
  flex-direction: column-reverse;
  }
  .left-content{
  width: 100%;
  padding-right: 15px;
  overflow: hidden;
  }
  .box-wrapper{
  width: auto;
  max-height: 250px;
  height: 250px;
  position: relative;
  top: 0;
  display: block;
  padding-top: 10px;
  margin-left: 15px;
  margin-right: 20px;
  margin-bottom: 0;
  }
  .box-container{
  display: grid;
  margin-bottom: 15px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  }
  /* Dashboard Capacity */
  .box-wrapper{
  /* border-left: 3px solid rgba(0, 0, 0, 0.25) !important; */
  width: -moz-max-content;
  width: 100%;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 35px 0px;
  position: sticky;
  max-height: 625px;
  top: 90px;
  overscroll-behavior: contain;
  background-color: white;
  border-radius: 8px;
  margin-right: 35px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
  }
  .box-wrapper::-webkit-scrollbar{
  display: none;
  }
  .box {
  align-items: center;
  padding: 10px 10px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  width: 50%;
  margin: 0 auto 15px auto;
  }
  .vertical {
  /* display: flex; */
  vertical-align: bottom;
  }
  .box-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding: 20px 20px;
  /* margin-bottom: 15px; */
  width: 50%;

  }
  .box-container:nth-child(1){
  border-right: 1px solid rgba(0, 0, 0, 0.25);
  margin-top: 20px;
  padding-top: 0px;
  margin-bottom: 15px;
  }
  .box-content{
  /* display: flex; */
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 5px;
  background-color: whitesmoke;
  color: black;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
  }
  /* Set Color */
  .bar-capacity{
  width: 100%;
  height: fit-content;
  background-color: gray;
  /* margin-top: 12px; */
  margin-top: 1px;
  border-radius: 5px;
  position: relative;
  border-radius: 4px;
  }
  .bar-precentage{
  height: 12px;
  border-radius: 4px;
  }
  .bar-green{
  height: 12px;
  border-radius: 4px;
  /* background-color: rgb(2, 220, 2); */
  }
  .bar-yellow{
  height: 12px;
  border-radius: 4px;
  background-color: yellow;
  }
  .bar-red{
  height: 12px;
  border-radius: 4px;
  background-color: red;
  }
  .bar-gray{
  height: 12px;
  border-radius: 4px;
  background-color: gray;
  pointer-events: none;
  cursor: not-allowed;
  }
  .full-container {
  width: 100%;
  height: auto;
  /* background-color: red; */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  grid-template-columns: repeat(1, 1fr);
  column-gap: 20px;
  row-gap: 40px;
  padding-bottom: 35px;
  margin-bottom: 35px;
  padding-top: 20px;
  padding-left: 0px !important;
  position: relative;
  }

  .full-container .sub-container_ {
  width: 100%;
  height: auto;
  /* background-color: green; */
  border: 2px solid gray;
  padding-top: 10px;
  padding: 8px;
  margin-right: 25px;
  margin-left: 25px;
  }

  .full-container .sub-container_ .title-group {
  width: 100%;
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  color: black;
  margin-bottom: 12px;

  }

  .full-container .sub-container_ .container_ {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  column-gap: 20px;
  row-gap: 40px;
  }

  /* @media (min-width: 640px) {
    .full-container .sub-container_ .container_ {
      grid-template-columns: repeat(2, 1fr);
    }
  } */

  /* @media (min-width: 1024px) {
    .full-container .sub-container_ .container_ {
      grid-template-columns: repeat(5, 1fr);
    }
  } */

  @media (min-width: 1280px) {
  .full-container {
  grid-template-columns: repeat(2, 1fr);
  }
  }

  .full-container .sub-container_ .container_ .card {
  width: 100%;
  min-height: 120px;
  display: flex;
  flex: nowrap;
  /* background-color: blue; */
  }

  .container_ .card .header-content_ {
  width: 100%;
  /* background-color: yellow; */
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  color:  black;
  }

  .container_ .card .sub-content {
  width: 100%;
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  }

  .container_ .card .sub-content .content {
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  padding: 8px;
  margin-bottom: 12px;
  }

  .container_ .card .sub-content .content:nth-last-child(1) {
  margin-bottom: 0;
  }

  .sub-content .content .title-content_ {
  width: 100%;
  font-weight: 700;
  font-size: 16px !important;
  margin-bottom: 8px;
  }

  .sub-content .content table {
  width: 100%;
  margin-bottom: 8px;
  }

  .sub-content .content table tr td {
  font-size: 12px;
  }

  .sub-content .content table tr td:nth-child(1) {
  font-weight: 600;
  width: 80px;
  vertical-align: top;
  }
  .sub-content .content table tr td:nth-child(2) {
  font-weight: 600;
  width: 10px;
  text-align: center;
  vertical-align: top;
  }

  .sub-content .content .bar-capacity {
  width: 100%;
  height: 16px;
  background-color: lightgray;
  position: relative;
  margin-top: 1px;
  }

  .sub-content .content .bar-capacity .bar-value {
  width: 60%;
  height: 16px;
  margin-top: 1px;
  /* background-color: rgb(7, 189, 7); */
  }
  .wide-modal {
  width: 100% !important;
  }
  </style>
